import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { CreateEventPayload, EventUploadUrlData } from '../types';

export function useCreateEvent() {
  const {
    data: uploadUrlData,
    isFetching,
    refetch: refetchUploadUrl,
  } = useApiQuery<EventUploadUrlData>('/events/upload-url', {
    queryKey: ['eventUploadUrl'],
    initialData: null,
  });

  const {
    data: uploadIdleStateUrlData,
    refetch: refetchIdleStateUploadUrl,
    isFetching: isFetchingIdleStateUploadUrl,
  } = useApiQuery<EventUploadUrlData>(
    `/events/idle-state-video-reupload-url/${uploadUrlData?.eventId}`,
    {
      queryKey: ['eventIdleStateUploadUrl'],
      initialData: null,
      enabled: !!uploadUrlData?.eventId,
    }
  );

  const createEventMutation = useApiMutation<CreateEventPayload>(
    '/events',
    {
      method: 'POST',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    uploadUrlData: {
      ...uploadUrlData,
      idleStateVideoPublicUrl: uploadIdleStateUrlData?.signedUrl,
    },
    refetchUploadUrl,
    createEventMutation,
    refetchIdleStateUploadUrl,
    isFetching: isFetching || isFetchingIdleStateUploadUrl,
  } as const;
}
